import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./CustomDevelopmentPage.scss";
import fcCustomDevelopment from "../../assets/images/banner-custom-development.png";
import Copyright from "../../components/Copyright/Copyright";

const CustomDevelopmentPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="feature-page">
      {/* Hero Section */}
      <section className="feature-hero">
        <div className="container">
          <div className="feature-hero-image">
            <img src={fcCustomDevelopment} alt="Custom Development" />
          </div>
        </div>
      </section>

      {/* Custom Development Information */}
      <section className="feature-info">
        <div className="container">
          <div className="feature-grid">
            <div className="feature-details">
              <h2>Custom development services</h2>
              <p>
                Transform your unique business requirements into powerful solutions with our
                custom development services. Our expert development team creates tailored
                features, integrations, and workflows that perfectly fit your business needs.
              </p>

              <div className="feature-methods">
                <div className="feature-method">
                  <div className="method-content">
                    <h3>Custom features</h3>
                    <p>
                      Develop bespoke features and modules specifically designed for your
                      business processes and requirements.
                    </p>
                  </div>
                </div>

                <div className="feature-method">
                  <div className="method-content">
                    <h3>Workflow automation</h3>
                    <p>
                      Build automated workflows and business processes that streamline
                      your operations and reduce manual tasks.
                    </p>
                  </div>
                </div>

                <div className="feature-method">
                  <div className="method-content">
                    <h3>Mobile applications</h3>
                    <p>
                      Build native mobile apps for iOS and Android.
                    </p>
                  </div>
                </div>

                <div className="feature-method">
                  <div className="method-content">
                    <h3>Integration development</h3>
                    <p>
                      Build custom integrations with your existing systems and third-party applications.
                    </p>
                  </div>
                </div>

                <div className="feature-method">
                  <div className="method-content">
                    <h3>Other solutions</h3>
                    <p>
                      Build a custom solution from scratch to fit your business needs.
                    </p>
                  </div>
                </div>

              </div>
            </div>

            <div className="feature-features">
              <h2>Key features</h2>
              <div className="features-list">
                <div className="feature-item">
                  <h3>Tailored solutions</h3>
                  <p>Custom-built features designed specifically for your business requirements and workflows.</p>
                </div>

                {/* <div className="feature-item">
                  <h3>Seamless integration</h3>
                  <p>Connect CashManager with your existing systems and third-party applications.</p>
                </div> */}

                <div className="feature-item">
                  <h3>Scalable architecture</h3>
                  <p>Solutions built to grow with your business and handle increasing data volumes.</p>
                </div>

                <div className="feature-item">
                  <h3>Quality assurance</h3>
                  <p>Rigorous testing and quality control to ensure reliable and robust solutions.</p>
                </div>

                <div className="feature-item">
                  <h3>Ongoing support</h3>
                  <p>Continuous maintenance and support for all custom-developed solutions.</p>
                </div>

                {/* <div className="feature-item">
                  <h3>Documentation</h3>
                  <p>Comprehensive documentation and training for all custom features and integrations.</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Development Services */}
      <section className="supported-section">
        <div className="container">
          <div className="section-header">
            <h2>Development services</h2>
            <p>Comprehensive custom development solutions to meet your specific business needs</p>
          </div>

          <div className="items-grid">
            <div className="item">
              <h3>Custom modules</h3>
              <ul>
                <li>Specialized reporting modules</li>
                <li>Custom data entry forms</li>
                <li>Industry-specific workflows</li>
                <li>Advanced analytics dashboards</li>
                <li>Custom user interfaces</li>
                <li>Specialized calculation engines</li>
              </ul>
            </div>

            <div className="item">
              <h3>Integration development</h3>
              <ul>
                <li>ERP system integration</li>
                <li>CRM platform connections</li>
                <li>Banking system APIs</li>
                <li>Third-party service integration</li>
                <li>Legacy system migration</li>
                <li>Real-time data synchronization</li>
              </ul>
            </div>

            <div className="item">
              <h3>Workflow automation</h3>
              <ul>
                <li>Automated approval processes</li>
                <li>Custom business rules</li>
                <li>Automated notifications</li>
                <li>Data validation workflows</li>
                <li>Automated report generation</li>
                <li>Custom scheduling systems</li>
              </ul>
            </div>

            {/* <div className="service-item">
              <h3>Mobile applications</h3>
              <ul>
                <li>Mobile-responsive interfaces</li>
                <li>Native mobile apps</li>
                <li>Offline functionality</li>
                <li>Mobile-specific features</li>
                <li>Cross-platform compatibility</li>
                <li>Mobile security implementation</li>
              </ul>
            </div>
             */}
          </div>
        </div>
      </section>

      {/* Development Process */}
      <section className="implementation-process">
        <div className="container">
          <div className="section-header">
            <h2>Development process</h2>
            <p>Our proven methodology ensures successful delivery of custom solutions</p>
          </div>

          <div className="process-steps five-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Requirements analysis</h3>
                <p>Thorough analysis of your business requirements and technical specifications.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Solution design</h3>
                <p>Create detailed technical specifications and architecture for your custom solution.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Development & testing</h3>
                <p>Build and thoroughly test your custom solution in a controlled environment.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Deployment & training</h3>
                <p>Deploy to production and provide comprehensive training for your team.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">5</div>
              <div className="step-content">
                <h3>Ongoing support</h3>
                <p>Provide continuous maintenance, updates, and support for your custom solution.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to build your custom solution?</h2>
            <p>
              Let our development team create the perfect solution for your business needs.
              Contact us today to discuss your custom development requirements.
            </p>
            <Link to="/onboarding" className="btn btn-secondary btn-large">Get started</Link>
          </div>
        </div>
      </section>

      {/* Copyright Section */}
      <Copyright />
    </div>
  );
};

export default CustomDevelopmentPage;
